import { reactive, inject, InjectionKey, provide } from '@vue/composition-api'

export type KaiError = {
  message: string
}

export interface ErrorsState {
  errors: Array<KaiError>
}

export const addError = (error: KaiError): void => {
  const errorsState = useErrorsState()
  errorsState?.errors?.push(error)
}

export const ErrorsStateKey: InjectionKey<ErrorsState> = Symbol('errorsState')
export const errorsState = () =>
  reactive({
    errors: []
  })

export const useErrorsState = () => inject(ErrorsStateKey)
export const provideErrorsState = () => provide(ErrorsStateKey, errorsState())
